<template>
  <div class="icons-container"> 
    <div class="block"> 
      <span class="btn">
        <el-color-picker v-model="color1"></el-color-picker>
        <el-button style="margin-left:10px;" @click="color1='inherit'">默认颜色</el-button>
        <el-button @click="color1='#1890ff'" type="primary"></el-button>
        <el-button @click="color1='#42d885'" type="success"></el-button>
        <el-button @click="color1='#a6a9ad'" type="info"></el-button>
        <el-button @click="color1='#ffc833'" type="warning"></el-button>
        <el-button @click="color1='#ff4949'" type="danger"></el-button>
        <el-input v-model="input" clearable style="width: 150px;margin-left: 20px;" placeholder="请输入内容">
          <i slot="prefix" class="el-input__icon el-icon-search" />
        </el-input>
      </span>
    </div>
    <el-tabs type="border-card"> 
      <el-tab-pane v-for="(item, index) of awesome" :key="index" :label="item.text">
        <div v-for="(i,index) of item.child" :key="index" @click="handleClipboard(i,$event)">
          <div class="icon-item" v-show='i.includes(input)'>
            <i :style="'color:'+color1" :class="'fa fa-' + i" />
            <span>{{ i }}</span>
          </div>
        </div>
      </el-tab-pane> 
    </el-tabs>
  </div>
</template>

<script> 
import svgIcons from './svg-icons'
import awesome from './font-awesome'
import elementIcons from './element-icons'
export default {
  name: 'Icons',
  data () {
    return {
      svgIcons,
      elementIcons,
      awesome: awesome.awesome, 
      color1: "inherit",
      input:'',
    }
  }, 
    methods: { 
    generateIconCode (symbol) {
      return `<svg-icon icon-class="${symbol}" />`
    },
    generateElementIconCode (symbol) {
      return `<i class="el-icon-${symbol}" />`
    },
    handleClipboard (text, event) {
      
      var d = 'fa fa-' + text + '/' + this.color1
      this.$emit('func', d) 
    },
    handleIconFont (text, event) {
      
      var d = 'iconfont ' + text + '/' + this.color1
      this.$emit('func', d) 
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-tabs--border-card>.el-tabs__content{
    padding-right: 0;
  }
.icons-container {
  margin: 10px 20px 0;
  overflow: hidden;
  .btn {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .icon-item {
    margin: 20px;
    height: 85px;
    text-align: center;
    width: 100px;
    float: left;
    font-size: 30px;
    color: #24292e;
    cursor: pointer;
  }

  span {
    display: block;
    font-size: 16px;
    margin-top: 10px;
  }

  .disabled {
    pointer-events: none;
  }
}
</style>
